import _ from 'lodash';
import PropTypes from 'prop-types';

/**
 * Helpers for pulling content out of pages
 */

export const getContentType = object => _.get(object, 'sys.contentType.sys.id');

export const getStringsForPage = (page = {}) =>
  _.reduce(page.unorderedShortText, (all, string) => {
    if (getContentType(string) === 'basicTextString') {
      all[_.get(string.fields, 'id')] = _.get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }
    return all;
  }, {});

export const getMarkdownStringsForPage = (page = {}) =>
  _.reduce(page.unorderedShortText, (all, string) => {
    if (getContentType(string) === 'textString') {
      all[_.get(string.fields, 'id')] = _.get(string.fields, 'text'); // eslint-disable-line no-param-reassign
    }
    return all;
  }, {});

export const getAssetsForPage = (page = {}) =>
  _.map(page.assets, asset => asset.fields);
/**
 * Load a specific section from a page.
 * We require type because IDs are only unique to a type
 * @param page
 * @param id
 * @param type
 */
export const getSectionForPageByIdAndType = (page, id, type) =>
  _.get(_.find(page.sections, {
    fields: { id },
    sys: {
      contentType: {
        sys: {
          id: type,
        },
      },
    },
  }), 'fields');

// Depreacted, use ui-common/models/page.js pagePropType
export const pagePropType = {
  title: PropTypes.string,
  internalName: PropTypes.string,
  id: PropTypes.string.isRequired,
  pageType: PropTypes.string,
  sections: PropTypes.arrayOf(PropTypes.object),
  unorderedShortText: PropTypes.arrayOf(PropTypes.object),
  slug: PropTypes.string,
  previewText: PropTypes.string,
};

export const pageStringsPropType = PropTypes.objectOf(PropTypes.string);



// WEBPACK FOOTER //
// ./app/common/selectors/page.js